import { getQueryKeys } from "../../helper";

const namespace = "passengers";

export default {
  ...getQueryKeys(namespace),
};
